import { Box, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PinnedItemRow } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/PinnedItemRow";

export type PinnedItem = {
	id: number;
	title: string;
	canUnpin: boolean;
};

type Props = {
	items: PinnedItem[];
	isPending: boolean;
	footnote?: string;
	onUnpin: (id: number) => void;
};

export const PinnedItems: FC<Props> = ({
	items,
	isPending,
	footnote,
	onUnpin,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();

	if (items.length === 0) {
		return null;
	}

	return (
		<Box pb={1.4}>
			<Typography
				variant="caption"
				color={palette.grey[400]}
				px={spacingTokens.lg}
				pb={spacingTokens.sm}
				textTransform="uppercase"
				display="block"
			>
				{t(Resources.PortfolioDetail.Pin.alreadyPinned)}
			</Typography>
			{items.map((item) => (
				<PinnedItemRow
					key={item.id}
					title={item.title}
					canUnpin={item.canUnpin}
					isPending={isPending}
					onUnpin={() => onUnpin(item.id)}
				/>
			))}
			{footnote && (
				<Typography
					variant="caption"
					color={palette.grey[500]}
					px={spacingTokens.lg}
					pt={spacingTokens.sm}
					display="block"
				>
					{footnote}
				</Typography>
			)}
		</Box>
	);
};
